import { startOfDay } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { CalendarEvent } from '../stores/useCalendarStore';

import { EventCard } from './EventCard';

interface EventListProps {
  events: CalendarEvent[];
  onDeleteEvent: (id: string) => void;
}

export const EventList = ({ events, onDeleteEvent }: EventListProps) => {
  const { t } = useTranslation();
  const sortedEvents = [...events].sort((a, b) => a.event_date.getTime() - b.event_date.getTime());

  // Use startOfDay to compare only dates, not times
  const today = startOfDay(new Date());
  const futureEvents = sortedEvents.filter(event =>
    startOfDay(event.event_date) >= today
  );

  return (
    <div className="max-w-2xl mx-auto">
      <div className="space-y-4">
        {futureEvents.length === 0 ? (
          <p className="text-sm text-gray-500">{t('calendarApp.noUpcomingEvents')}</p>
        ) : (
          futureEvents.map(event => (
            <EventCard
              key={event.id}
              event={event}
              onDelete={onDeleteEvent}
            />
          ))
        )}
      </div>
    </div>
  );
};
